var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 13.7143C1.86667 13.7143 1.50794 13.5651 1.20952 13.2667C0.911111 12.9683 0.761905 12.6095 0.761905 12.1905V2.28571H0V0.761905H3.80952V0H8.38095V0.761905H12.1905V2.28571H11.4286V12.1905C11.4286 12.6095 11.2794 12.9683 10.981 13.2667C10.6825 13.5651 10.3238 13.7143 9.90476 13.7143H2.28571ZM9.90476 2.28571H2.28571V12.1905H9.90476V2.28571ZM3.80952 10.6667H5.33333V3.80952H3.80952V10.6667ZM6.85714 10.6667H8.38095V3.80952H6.85714V10.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8a77688d3a1ca359bef05fc8c277bebf.svg";
export { ForwardRef as ReactComponent };